import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../services/firebase";

export const addLog = async (actionBy, action, details = {}) => {
  try {
    await addDoc(collection(db, "auditLogs"), {
      actionBy,
      action,
      details,
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error adding audit log:", error);
  }
};